<template>
        <li v-if="$slots.header" @click="onClickHeader(value, label)" class="header">
            <slot name="header" ></slot>
        </li>
        <li v-else :class="{'checked': checked}" v-show="visible" @click="onClickItem(value, label)">
            <span>{{label}}</span>
            <i class="el-icon-check" v-show="checked"></i>
        </li>
</template>
<script>
    export default {
        name: 'self-option',
        props: {
            value: [Number, String],
            label: String
        },
        data() {
          return {
              visible: true,
              checked: false,
          };
        },
        created() {
            this.$nextTick(() => {
                this.getEvent().$emit('initData', {value: this.value, label: this.label});
                this.getEvent().$on('setChecked', this.setChecked);
                this.getEvent().$on('clearChecked', this.clearChecked);
            })
        },
        mounted() {
            this.$parent.$on('query', this.query);
        },
        methods: {
            getEvent() {
                return  this.$parent;
            },
            query(str) {
                if(!this.label){
                    this.visible = false;
                    return;
                }
                let isEmpty = !str;
                if(isEmpty || (str && this.label.indexOf(str) > -1)){
                    this.visible = true;
                } else {
                    this.visible = false;
                }
            },
            
            onClickItem(value, label) {
                this.checked = !this.checked;
                this.getEvent().$emit('onClickItem', {value, label, checked: this.checked});
            },
            onClickHeader(value, label){
                this.getEvent().$emit('onClickHeader');
                this.$emit('onClick', {value, label});
            },
            setChecked({value, checked}) {
                if(value === this.value){
                    this.checked = checked;
                }
            },
            clearChecked(){
                this.checked = false
            }
        }
    }
</script>